"use strict";

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/createClass.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var innedit_1 = require("@innedit/innedit");

var Commande = /*#__PURE__*/function () {
  function Commande() {
    _classCallCheck(this, Commande);
  }

  _createClass(Commande, null, [{
    key: "calculateProduitsAmount",
    value: function calculateProduitsAmount(produits) {
      if (!produits || 0 === produits.length) {
        return 0;
      }

      return produits.reduce(function (cumul, produit) {
        var price = produit.price,
            quantity = produit.quantity;
        return cumul + quantity * (price || 0);
      }, 0);
    }
  }, {
    key: "confirmByUser",
    value: function confirmByUser(id, data) {
      var commandeData = new innedit_1.CommandeData({
        espaceId: String(process.env.GATSBY_ID_BOUTIQUE)
      });
      return commandeData.confirmByUser(id, data);
    }
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var commandeModel;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commandeModel = new innedit_1.CommandeData({
                  espaceId: String(process.env.GATSBY_ID_BOUTIQUE)
                });
                return _context.abrupt("return", commandeModel.create(data));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "findByCheckoutSessionId",
    value: function findByCheckoutSessionId(id) {
      return innedit_1.CommandeData.findByCheckoutSessionId(id);
    }
  }, {
    key: "getByUserId",
    value: function () {
      var _getByUserId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userId, id) {
        var commandeModel, commande;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commandeModel = new innedit_1.CommandeData({
                  espaceId: String(process.env.GATSBY_ID_BOUTIQUE)
                });
                _context2.next = 3;
                return commandeModel.findById(id);

              case 3:
                commande = _context2.sent;

                if (!(commande.userId !== userId)) {
                  _context2.next = 6;
                  break;
                }

                throw new Error("Cette commande n'appartient pas à cet utilisateur");

              case 6:
                return _context2.abrupt("return", commande);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getByUserId(_x2, _x3) {
        return _getByUserId.apply(this, arguments);
      }

      return getByUserId;
    }()
  }, {
    key: "getAllByUserId",
    value: function getAllByUserId(userId, options) {
      var commandeModel = new innedit_1.CommandeData({
        espaceId: String(process.env.GATSBY_ID_BOUTIQUE)
      });
      return commandeModel.find(_objectSpread({
        wheres: {
          userId: userId
        }
      }, options));
    }
  }, {
    key: "update",
    value: function update(id, data) {
      var commandeData = new innedit_1.CommandeData({
        espaceId: String(process.env.GATSBY_ID_BOUTIQUE)
      });
      return commandeData.update(id, data);
    }
  }]);

  return Commande;
}();

exports.default = Commande;